<template>
  <div>
    <div class="view-area video-filter">
      <div class="main-area">
        <img src="@/assets/logo_w.png" class="title-img">
      </div>
    </div>
    <Footer :isWhite="true" />
    <Menu :isWhite="true" />
    <video v-if="width < 749" class="bg-video" src="@/assets/aeka_top_sp.mp4" poster="@/assets/GettyImages-173046609.png" playsinline autoplay muted loop></video>
    <video v-else class="bg-video" src="@/assets/GettyImages-173046609.mp4" poster="@/assets/GettyImages-173046609.png" playsinline autoplay muted loop></video>
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'

export default {
  name: 'Index',
  components: {
    Footer,
    Menu
  },
  data () {
    return {
      width: window.innerWidth
    }
  },
  methods: {
    handleResize () {
      this.width = window.innerWidth
    }
  },
  async mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.bg-video{
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  background-size: cover;
}
.view-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.video-filter {
  background: rgba(20, 20, 20, 0.12);
}
.main-area {
  display: flex;
  flex-wrap: wrap;
}
.title-img {
  width: 192px;
  height: 239px;
}
@media (max-width: 639px) {
  .title-img {
    width: 137px;
    height: 171px;
    padding-bottom: 68px;
  }
}
/* footerが2行になるとき */
@media (max-width: 390px) {
  .title-img {
    width: 137px;
    height: 171px;
    padding-bottom: 89px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue